export { default } from './MetaCard';
